import { downloadFormSixteenFileProps } from '../../../../types/Finance/FormSixteenDownload/FormSixteenDownloadTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { formSixteenDownloadApiConfig, AllowedHttpMethods } from '../../apiList'

const downloadFormSixteenFile = async (
  props: downloadFormSixteenFileProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: formSixteenDownloadApiConfig.downloadFormSixteenFile,
    method: AllowedHttpMethods.get,
    params: {
      empId: props?.empId,
      year: props.year,
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const formSixteenDownloadApi = {
  downloadFormSixteenFile,
}

export default formSixteenDownloadApi
